<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <router-link :to="{ path: '/admin/article2/list' }">
          <Button icon="ios-arrow-back" size="small" class="mr20">返回</Button>
        </router-link>
        <span class="ivu-page-header-title mr20" v-text="$route.params.id >0 ? '编辑'+this.title : '添加'+this.title"></span>
      </div>
    </div>
    <div class="myModal">
      <Card :bordered="false" dis-hover class="ivu-mt">
        <Form ref="artInfo"  :model='artInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
          <form-item label="文章标题" prop="article_title">
            <Input placeholder="请输入" v-model="artInfo.article_title"></Input>
          </form-item>
          <FormItem label="图片/视频">
            <div class="demo-upload-list" v-for="item in uploadList" :key="item.url" >
              <template v-if="item.status === 'finished'">
<!--                <img :src="item.url">-->
                <img :src="handImgurl(item.url)" style="width: 100%">
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                  <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                </div>
              </template>
              <template v-else>
                <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
              </template>
            </div>
            <Upload
                    v-if="uploadList.length==0"
                    ref="uploadThumb"
                    :show-upload-list="false"
                    :on-success="handleSuccess"
                    :format="['jpg','jpeg','png','gif','mp4']"
                    :max-size="61440"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    type="drag"
                    :action="serverApiPic"
                    style="display: inline-block;width:58px;">
              <div style="width: 58px;height:58px;line-height: 58px;">
                <Icon type="ios-camera" size="20"></Icon>
              </div>
            </Upload>
            <Modal title="查看" v-model="visible">
              <span v-if="urltype == 1">
                <img :src="imgUrl" style="width: 100%;">
              </span>
              <span v-else>
                 <video autoplay controls :src="imgUrl " v-if="visible" style="width: 100%"></video>
              </span>
<!--              <img :src="imgUrl " v-if="visible" style="width: 100%">-->
            </Modal>
          </FormItem>
          <FormItem label="简介" prop="remark">
            <Input v-model="artInfo.short_detail" :rows="4" type="textarea"   placeholder="请输入简介"  ></Input>
          </FormItem>

          <form-item label="排序" prop="sort">
            <InputNumber :max="10000" :min="0" v-model="artInfo.sort"></InputNumber>
          </form-item>

          <form-item label="状态" prop="status">
            <i-switch v-model="artInfo.status" :value="artInfo.status" :true-value="1" :false-value="0" @on-change="changeSwitch()"></i-switch>
          </form-item>
        </Form>
      </Card>
    </div>
    <div slot="footer">
      <Button type="primary"   @click="handleOk('artInfo')">确定</Button>
    </div>
  </div>
</template>

<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
<script>
import { articleInfo, eidtArticle } from '@/api/article'
import ueditor from '@/components/ueditorFrom/index'
import Setting from '@/setting'
export default {
  name: 'listEdit',
  components: { ueditor },
  props: ['editShow', 'id'],
  data () {
    return {
      title: '文章',
      editor: null,
      isShow: false,
      urltype:1,
      article_id: 0,
      server_url: Setting.serverSrc,
      serverApiPic: Setting.serverApiPic,
      uploadList: [], // 缩咯图
      indexContent: [], // 首页模块数组
      imgUrl: '',
      visible: false,
      artInfo: {
        article_id: 0,
        article_title: '',
        sort: 0,
        type: 2,
        like: 0,
        status: 1,
        url: '',
        delpics: [], // 服务器待删除的照片
        is_top: 0,
      },
      homesaty: [], // 全部美住
      ruleValidate: {
        article_title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    // this.homesaty_getalllist()
    if (this.$route.params.id > 0) {
      this.articleInfo()
    } else {
      this.artInfo.sort = Number(this.$route.params.sort)
    }
    // this.indexContents()
  },
  methods: {
    handleOk (name) {
      this.artInfo.article_info = this.$refs.ueDetail.contents
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.uploadList.length <= 0) {
            this.$Message.error('广告图必填')
            return
          }
          this.artInfo.cover = this.uploadList[0]['url']

          eidtArticle(this.artInfo).then(res => {
            let msg = '添加成功'
            if (this.artInfo.article_id > 0) {
              msg = '编辑成功'
            }
            if (res.code === 200) {
              this.$Message.success(msg)
              this.$router.push({ path: '/admin/article2/list' })
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },
    selectChange (val) {
      this.artInfo.homestay_id = val
    },
    radioChange (val) {
      this.artInfo.redirect_type = val
    },
    changeSwitch (val) {
      this.artInfo.status = val
    },
    articleInfo () {
      if (this.$route.params.id) {
        let data = { 'article_id': this.$route.params.id }
        articleInfo(data).then(res => {
          this.artInfo = res.data
          this.artInfo.delpics = []
          this.$refs.ueDetail.contents = this.artInfo.article_info
          this.uploadList.push({ 'url': this.artInfo.cover, 'showProgress': false, 'percentage': 100, 'status': 'finished' })
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      }
    },
    homesaty_getalllist () {
      homesaty_getalllist().then(res => {
        this.homesaty = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    handleView (url) {
      this.str = url.replace(/.+\./, "");

      if(this.str === 'mp4'){
        this.urltype = 2
      }else{
        this.urltype = 1
      }
      this.imgUrl = url
      this.visible = true
    },
    handImgurl(url){
      var str = url.replace(/.+\./, "");
      if(str === 'mp4'){
        return url+'?x-oss-process=video/snapshot,t_3000,f_jpg,w_60,m_fast'
      }else{
        return url
      }
    },
    // 缩略图删除
    handleRemove (file) {
      const fileList2 = this.uploadList
      this.artInfo.delpics.push(file.url)
      this.uploadList.splice(fileList2.indexOf(file), 1)
      this.uploadList = []
    },
    // 缩略图
    handleSuccess (res, file) {
      let file_url = res.data.file_url
      if (file_url.substring(0, 5) === 'https') {
        file.url = file_url
      } else {
        file.url = this.server_url + file_url
      }
      this.uploadList = this.$refs.uploadThumb.fileList
    },
    handleFormatError (file) {
      this.$Message.error('文件' + file.name + '格式错误，请上传jpg或者png')
    },
    handleMaxSize (file) {
      this.$Message.error('文件' + file.name + '太大，不能大于50M')
    },
    // 缩略图
    handleBeforeUpload () {
      const check = this.uploadList.length < 1
      if (!check) {
        this.$Message.error('只能上传1张图片')
      }
      return check
    },
    // // 首页数据
    // indexContents () {
    //   getIndexCate().then(res => {
    //     this.indexContent = res.data
    //   }).catch(res => {
    //     this.$Message.error(res.msg)
    //   })
    // }
  }
}
</script>
